import {
    BUDGETS_PROPOSALS_REQUEST_FAIL,
    BUDGETS_PROPOSALS_REQUEST_SUCCESS,
} from '../action.types';
import initialState from '../initial.state';

export default function (state = initialState.budgetProposals, action) {
    switch (action.type) {
        case BUDGETS_PROPOSALS_REQUEST_SUCCESS:
            return { ...action.payload };
        case BUDGETS_PROPOSALS_REQUEST_FAIL:
            return state;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/budget/proposals.reducer.js